import * as React from "react";
import { Button } from "antd";

interface IProps {
	vitalsId?: number;
	vitalsScore?: number;
	dataLocked: boolean;
	vitalsDateCompleted?: string;
	licensedProductContainsVitals: boolean;
	customFieldNotValidated: boolean;
	DCATRunning: boolean;
	DCATButtonClicked: boolean;
	canSync: boolean;
	getVitalsTest: () => void;
	resumeVitalsTest: () => void;
	startVitalsTest: () => void;
	canEditVitals: boolean;
}

const VitalsButton: React.FC<IProps> = (props) => {
	let vitalsScoredDated =
		props.vitalsDateCompleted != undefined
			? props.vitalsDateCompleted
			: undefined;

	let button = (
		<Button
			className="mr-auto btn-primary"
			disabled={
				!props.canSync ||
				props.DCATRunning ||
				props.DCATButtonClicked ||
				!props.customFieldNotValidated ||
				!props.canEditVitals
			}
			onClick={props.startVitalsTest}
		>
			Start VITALS
		</Button>
	);

	if (props.vitalsId && vitalsScoredDated !== undefined) {
		button = (
			<Button
				className="mr-auto btn-primary"
				onClick={props.getVitalsTest}
				disabled={
					!props.canSync ||
					props.DCATRunning ||
					props.DCATButtonClicked ||
					props.dataLocked ||
					!props.customFieldNotValidated ||
					!props.canEditVitals
				}
			>
				Edit VITALS
			</Button>
		);
	}

	if (props.vitalsId && vitalsScoredDated === undefined) {
		button = (
			<Button
				className="mr-auto btn-primary"
				onClick={props.resumeVitalsTest}
				disabled={
					!props.canSync ||
					props.DCATRunning ||
					props.DCATButtonClicked ||
					props.dataLocked ||
					!props.customFieldNotValidated ||
					!props.canEditVitals
				}
			>
				Resume VITALS
			</Button>
		);
	}

	if (!props.licensedProductContainsVitals) {
		button = <React.Fragment />;
	}

	return <React.Fragment>{button}</React.Fragment>;
};

export default VitalsButton;
